@use '../../styles/global' as *;
@use '../tooltip/style.scss' as *;
